import { routes as widget } from './widget'
import { routes as transfer } from './transfer'
import { routes as institution } from './institution'

export default [ ...widget, ...transfer, ...institution ]



// WEBPACK FOOTER //
// ./src/app/courseReportingWidgetRoutes.js